import { defineStore } from 'pinia'

type State = {
  notFound: boolean
}

/**
 * URLを変更せずにNotFoundを表示できるようにするためのStore
 * 他の種類も出てきたらglobalPageStoreとかでまとめても良いかも
 */
export const useNotFoundStore = defineStore('notFound', {
  state: (): State => {
    return {
      notFound: false
    }
  },
  actions: {
    setNotFound() {
      this.notFound = true
    }
  }
})
